type IButton = {
  link?: string;
  newWindow?: boolean;
  locale: string;
  handleClick?: () => void;
};

type ButtonProps =
  | {
      tag: 'a';
      href: string;
      rel: string;
      target?: string;
    }
  | {
      onClick: () => void;
    };

/**
 * This is similar to getButtonProps on helpers package, but without react-router-dom
 */
export const getButtonProps = ({ handleClick, link, newWindow = false, locale }: IButton): ButtonProps | undefined => {
  if (link)
    return {
      tag: 'a',
      href: link.startsWith('/') || link.startsWith('?') ? `/${locale}${link}` : link,
      rel: 'noopener noreferrer',
      target: newWindow ? '_blank' : undefined,
    };

  if (handleClick) {
    return {
      onClick: handleClick,
    };
  }

  return undefined;
};
